/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { EventClass, EventType } from "../../../config/Events";
import { __EventDispatcher, __UrlParams } from "../../../../_core/core";
import "./FailedBets.css";
import { connect } from "react-redux";
import { PROVIDER_URL } from "../../../../_core/config/config.App";
import { store } from "../../../../_core/core.Store";

const FailedBets = (_props: any) => {
  const [displayFailedBets, setDisplayFailedBets] = useState<boolean>(false);

  const onEventDispatched = (
    eventClass: EventClass,
    eventType: string,
    eventPayload: any
  ) => {
    if (eventClass === EventClass.GUI) {
      switch (eventType) {
        case EventType.GUI.SHOW_FAILED_BETS:
          if (eventPayload) {
            setDisplayFailedBets(true);
          }
          break;
      }
    }
  };

  const closeFailedBets = () => setDisplayFailedBets(false);

  //on mounted
  useEffect(() => {
    __EventDispatcher.addListener(EventClass.GUI, onEventDispatched, this);
  }, []);

  if (!displayFailedBets) return null;
  console.log("display tickets", _props.failedBets);
  const parseStatusToUrl = (status: string) => {
    switch (status) {
      case "CANCELLED":
        return "Cancelled";
      case "FAILED":
        return "Failed";
      case "TO_BE_CANCELED":
        return "ToBeCancelled";
      default:
        return "";
    }
  };

  const goToHistory = (ticket: any, status: string) => {
    const url = new URL(PROVIDER_URL.BETDETAILS);

    url.searchParams.append("transID", String(ticket.betID));
    url.searchParams.append("gameID", __UrlParams.props.gameID);
    url.searchParams.append("siteID", __UrlParams.props.siteID);
    url.searchParams.append("status", parseStatusToUrl(status));
    url.searchParams.append(
      "fixedID",
      store.getState().game.SESSION_DATA.fixedID
    );

    window.open(url.toString(), "_blank")?.focus();
  };

  const parseStatusLabel = (status: string) => {
    switch (status) {
      case "CANCELLED":
        return "Cancelled";
      case "FAILED":
        return "Failed";
      case "TO_BE_CANCELED":
        return "To be canceled";
    }
  };

  return (
    <div className="failed-bet-overlay">
      <div className="failed-bet-box">
        <div className="failed-box-header">
          <h3 className="failed-box-title">Failed Bets</h3>
          <button onClick={() => closeFailedBets()}>x</button>
        </div>
        <div className="failed-box-content">
          <table className="failed-tickets-table">
            <tbody>
              {_props.failedBets &&
                _props.failedBets.map((ticket: any, index: number) => (
                  <tr key={`GamePrize${index}`}>
                    <td>{ticket.extBetID}</td>
                    <td>{parseStatusLabel(ticket.status)}</td>
                    <td align="right">
                      <a
                        href="javascript:"
                        onClick={() => goToHistory(ticket, ticket.status)}
                      >
                        bet details
                      </a>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    failedBets: state.game.GAMEPLAY.failedBets,
  };
};

export default connect(mapStateToProps, {})(FailedBets);
